import BigNumber from 'bignumber.js';
import Vue from 'vue';
export default Vue.extend({
    name: 'BonusTableSummary',
    props: {
        prices: {
            type: Object,
            required: true
        },
        assets: {
            type: Object,
            required: true
        },
        selected: {
            type: String,
            required: true
        }
    },
    computed: {
        selectedAssets() {
            if (this.selected.length === 0)
                return Object.keys(this.assets);
            return [this.selected];
        },
        sum() {
            return this.selectedAssets.reduce((sum, asset) => {
                var _a;
                if (!this.assets[asset])
                    return BigNumber(0);
                return sum.plus(this.assets[asset].multipliedBy(asset === 'USDT' ? 1 : ((_a = this.prices[asset]) !== null && _a !== void 0 ? _a : 0)));
            }, BigNumber(0));
        },
        assetsString() {
            return this.selectedAssets
                .map((name) => {
                if (!this.assets[name])
                    return '';
                return this.$options.filters.replaceDot(this.assets[name].toFixed(name === 'BNB' ? 8 : 2)) + ' ' + name;
            })
                .join(', ');
        }
    }
});
